<div
  style="
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    overflow: auto;
    padding-left: 2em;
  "
>
  <ng-container *ngIf="!(listData && listData.length > 0); else listTemplate">
    <p style="text-align: center">No data to display</p>
  </ng-container>

  <ng-template #listTemplate>
    <table mat-table [dataSource]="dataSource" class="sub-table">
      <ng-container
        *ngFor="let column of displayedColumns"
        [matColumnDef]="column"
      >
        <!-- Primary rows -->
        <ng-container
          *ngIf="!column.startsWith('__action_'); else actionColumn"
        >
          <th mat-header-cell *matHeaderCellDef>
            {{ column | titlecase }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
        <ng-template #actionColumn>
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <!-- Handle action columns, switch based on cell content -->
            <ng-container
              [ngSwitch]="element[column]?.actionComponent || element[column]"
            >
              <ng-container *ngSwitchCase="'example_buttons'">
                <!-- Add your buttons component here -->
                <!-- Example: <example-buttons [rowData]="element"></example-buttons> -->
                <div>Buttons Placeholder</div>
              </ng-container>
              <ng-container *ngSwitchCase="'annotation_buttons'">
                <annotation-buttons
                  [annotationId]="
                    element[column]?.annotationId ||
                    element.Id ||
                    element.annotationId
                  "
                  [documentId]="
                    element[column]?.documentId ||
                    element.DocumentId ||
                    element.Document?.Id
                  "
                  [isPDF]="
                    element[column]?.isPDF !== undefined
                      ? element[column].isPDF
                      : element.IsPDF
                  "
                >
                </annotation-buttons>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <!-- Default case for unknown action types -->
                <div>
                  Unknown Action:
                  {{ element[column]?.actionComponent || element[column] }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="toggleRow(row)"
        [class.demo-row-is-clicked]="isRowExpanded(row)"
      ></tr>
    </table>
  </ng-template>
</div>
